module.exports = __webpack_public_path__ + "media/fonts/OFN-v2-24a0188d851ab3cede0b38850ed1eb4e.woff";